// extracted by mini-css-extract-plugin
export var contentCard = "bn_dH";
export var gridBase = "bn_dD";
export var gridElement = "bn_dJ";
export var gridTumbleIn = "bn_dK";
export var heightAuto = "bn_dG";
export var heightFull = "bn_dF";